import React from "react"
import { connect } from "react-redux"

import {
    addFeedPreviewTyping,
    addFeedClose
} from "../../../actions/add-feed-actions"

import SpinnerImage from "../../common/SpinnerImage"
import AddFeedSavedNotice from "./AddFeedSavedNotice"
import UrlPreviewCard from "./UrlPreviewCard"

export const KnowledgeAnalyseWidget = ({
    isFetchingItem,
    onClose,
    previewURL,
    isFetchingPreview,
    hasPreviewLoaded,
    hasAnalysisCompleted,
    isSaved,
    moderationStatus,
    dataToAnalyse,
    onPreviewSearch,
    hasError,
    errorMessage
}) => (
    <div className="widget">
        <header className="widget-header">
            <h3>
                <span className="icon icon-add-feed" />
                Add knowledge&nbsp;
                {(isFetchingItem || isFetchingPreview) && <SpinnerImage />}
                <div className="pull-right edge-pull-right-fix">
                    <span
                        className="close"
                        onClick={onClose}
                        aria-label="close"
                        aria-hidden="true"
                    >
                        &times;
                    </span>
                </div>
            </h3>
            <div className="add-feed-inputs">
                <input
                    className="form-control"
                    type="text"
                    value={dataToAnalyse}
                    onChange={onPreviewSearch}
                    placeholder="Enter a web link"
                />
            </div>
            {hasError && (
                <p style={{ color: "red", marginBottom: "0px" }}>
                    {errorMessage || "An error has occurred, please try again."}
                </p>
            )}
        </header>
        {previewURL && !hasAnalysisCompleted && (
            <div
                className={`widget-content ${
                    isFetchingPreview || hasPreviewLoaded ? "active" : ""
                }`}
                id="previewer"
            >
                <UrlPreviewCard previewURL={previewURL} hasError={hasError} />
            </div>
        )}
        {hasAnalysisCompleted && isSaved && (
            <AddFeedSavedNotice
                moderationStatus={moderationStatus}
                onDone={onClose}
            />
        )}
    </div>
)

const mapStateToProps = ({ presentation: { addFeed } }) => ({
    isFetchingItem: addFeed.isFetchingItem,
    previewURL: addFeed.previewURL,
    isFetchingPreview: addFeed.isFetchingPreview,
    hasAnalysisCompleted: addFeed.hasAnalysisCompleted,
    hasPreviewLoaded: addFeed.hasPreviewLoaded,
    // An analysed link comes back with an id once it's saved, which also puts the form in edit mode
    isSaved: addFeed.isEditMode,
    moderationStatus: addFeed.workingModel.approved,
    dataToAnalyse: addFeed.dataToAnalyse,
    title: addFeed.titleToAnalyse,
    hasError: addFeed.error,
    errorMessage: addFeed.errorMessage
})

const mapDispatchToProps = dispatch => ({
    onPreviewSearch: ({ target }) =>
        dispatch(addFeedPreviewTyping(target.value.trim())),
    onClose: () => dispatch(addFeedClose())
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(KnowledgeAnalyseWidget)
